import './ThemeToggle.scss';

import { FC } from 'react';
import { IconButton } from '@mui/material';

import { useTheme } from 'app/theme/ThemeContext';

import { ReactComponent as SunIcon } from 'app/assets/sun.svg';
import { ReactComponent as MoonIcon } from 'app/assets/moon.svg';
import clsx from 'clsx';

interface IThemeToggle {
  className?: string;
}

const ThemeToggle: FC<IThemeToggle> = ({ className }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <IconButton
      disableRipple
      className={clsx('icon-button', 'theme-toggle', className)}
      onClick={toggleTheme}
    >
      {theme === 'light' ? <MoonIcon /> : <SunIcon />}
    </IconButton>
  );
};

export default ThemeToggle;
